import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { WebhookComponent } from './webhook.component';

const routes: Routes = [
  { path: '', component: WebhookComponent, },
];

@NgModule({
  imports: [RouterModule.forChild(routes), ReactiveFormsModule,],
  exports: [RouterModule]
})
export class WebhookRoutingModule { }
